import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../cms/block/abstract-cms-block.component';

interface IReceiveOrderCmsBlock extends NICmsContentComponent.IData {
    title?: string;
}

const config: Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'> = {
    id: 'receive-order-cmsblock',
    block: {
        url: 'receive-order-cmsblock'
    },
    onDemandOnly: true,
    name: 'Receive order title',
    description: 'Receive order title',
    fields: [
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Receive order title',
            default: 'How would you like to receive your order?'
        }
    ]
};

@Component({
    selector: 'receive-order-cmsblock',
    templateUrl: './receive-order-cmsblock.html',
    standalone: true,
    imports: [ICmsClientModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<ReceiveOrderCmsBlockComponent>(config)
export class ReceiveOrderCmsBlockComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IReceiveOrderCmsBlock;

    override canDetach = false;
}
